module.exports = __webpack_public_path__ + "img/gcla.ef7bb705.png";